<template>
  <div class="table-indicator-item" @mouseenter="percentAnimOver = true" @mouseleave="percentAnimOver = false" :class="{ 'hide-precent': hidePercent }">
    <div class="bar">
      <div class="percent" :style="{ width: average + '%' }" :class="[color]"/>
      <div class="amount text-truncate">{{ amount | formatNum }}<span v-if="includeTotal">&nbsp;de {{ total | formatNum }}</span><span>&nbsp;{{ suffix }}</span><span class="kpi-name" v-show="name">&nbsp;{{ name }}</span></div>
      <div class="ranking" v-if="amountToCompare !== false">
        <div class="indicator" :class="{ positive: amount > amountToCompare, negative: amount < amountToCompare }">
          <i class="up fas fa-arrow-up"></i>
          <i class="down fas fa-arrow-down"></i>
        </div>
      </div>

      <div class="percent anim" :style="{ width: percentAnimOver ? average + '%' : 0 }" :class="[color]"/>
      <div class="amount anim">{{ formatttedAverage + ' %' }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({
  filters: {
    formatNum (value: number) {
      return value.toLocaleString('en')
    }
  }
})
export default class TableKpiItem extends Vue {
  @Prop({ required: false, default: '' })
  name: string

  @Prop({ required: true, default: 0 })
  amount: number

  @Prop({ required: true, default: 0 })
  total: number

  @Prop({ required: false, default: false })
  amountToCompare: number

  @Prop({ required: false, default: false })
  includeTotal: boolean

  @Prop({ required: false, default: '' })
  suffix: string

  @Prop({ required: false, default: 'blue' })
  color: string

  @Prop({ required: false, default: false })
  hidePercent: boolean

  average = 0
  ranking = 0
  percentAnimOver = false;

  mounted () {
    this.calc()
  }

  calc () {
    this.average = this.total ? this.amount / this.total * 100 : 0
    this.ranking = this.amount - this.amountToCompare
  }

  get formatttedAverage () {
    return this.average.toFixed(1)
  }

  @Watch('total')
  watchTotal () {
    this.calc()
  }

  @Watch('amount')
  watchAmount () {
    this.calc()
  }

  @Watch('amountToCompare')
  watchAmountToCompare () {
    this.calc()
  }
}
</script>
